"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.freeze");

var _utils = require("../helpers/utils");

var _bind = _interopRequireDefault(require("../mixins/bind"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Mixin: Esc event
 * -----------------------------------------------------------------------------
 * Mixin to trigger events based on a global esc key event.
 *
 */

/**
 * Export esc event helper.
 */


var _default = function _default() {
  /**
   * Initialise component bind to prevent double binds.
   */
  var binder = (0, _bind["default"])(document.documentElement, {
    className: 'esc-bind'
  });
  /**
   * Set Esc keyboard event.
   * @param {Event} event - Keycode event set on document.
   */

  function onEscEvent(event) {
    if (!isKeyPressIsEsc(event) || !binder.isSet()) {
      return;
    }

    Frame.EventBus.emit('EscEvent:on');
    binder.remove();
  }
  /**
   * Check if Esc is pressed.
   * @param {Event} event - Keycode event passed from document.
   */


  function isKeyPressIsEsc(event) {
    return event.keyCode === 27;
  }
  /**
   * Listen for keydown events.
   */


  function setKeyDownToggleEvent() {
    if (binder.isSet()) {
      return;
    }

    (0, _utils.on)('keydown', function (event) {
      return onEscEvent(event);
    });
    binder.set();
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    set: setKeyDownToggleEvent
  });
};

exports["default"] = _default;